import { fetcher } from '#lib/backendFetcher';

/**
 * Fetches the company profile (org-level sender/brand data).
 *
 * @returns {Promise<Object>}
 */
export const fetchCompanyProfile = () => fetcher('/api/v1/platform/orgs/company-profile');

/**
 * Updates the company profile.
 *
 * @param {Object} params
 * @param {Object} params.updates - Fields to update
 * @param {string} [params.updates.name] - Company name (org-level)
 * @param {string} [params.updates.street] - Street address
 * @param {string} [params.updates.postal] - Postal code
 * @param {string} [params.updates.city] - City
 * @param {string} [params.updates.phone] - Phone number
 * @param {string} [params.updates.website] - Website URL
 * @param {string} [params.updates.logoUrl] - Logo URL
 * @param {string} [params.updates.registration] - Trade register entry
 * @param {string} [params.updates.defaultFooterText] - Default footer for letter templates
 * @param {string} [params.updates.brandPrimaryColor] - Brand primary color (hex)
 * @returns {Promise<Object>}
 */
export const updateCompanyProfile = ({ updates }) =>
	fetcher('/api/v1/platform/orgs/company-profile', {
		method: 'PATCH',
		body: updates,
	});
